var storageReader = (function() {
  var defaultConfig = {
    type: 'local',
    onlyJSON: false,
    namespace: ''
  }

  var getLocalConfig = function() {
    return Object.assign({}, defaultConfig); 
  }

  var StorageReader = function(config) {
    this.config = Object.assign(getLocalConfig(), config);

    this.storer = function(name, value) {
      if (!value || !name) { return false; }

      name = this.config.namespace + name;

      if (this.config.type && this.config.type === 'session') {
        sessionStorage.setItem(name, value);
      } else {
        localStorage.setItem(name, value);
      }

      this.notify('set', name, value);
    }

    this.loader = function(name) {
      if (!name) { return false; }

      name = this.config.namespace + name;

      var value = localStorage.getItem(name);

      if (this.config.type && this.config.type === 'session') {
        value = sessionStorage.getItem(name);
      }

      return value;
    }

    // notifier
    this.onChange = {};

    this.notify = function(event_name, name, value) {
      if (event_name == 'set') {
        if (this.onChange.set) {
          this.onChange.set(name, value);
        }
      }
    }

    this.on = function(event_name, callback) {
      this.onChange[event_name] = callback; 
    }

    this.removeItem = function(name) {
      if (!name) { return; }

      if (this.config.type && this.config.type === 'session') {
        sessionStorage.removeItem(name);
      } else {
        localStorage.removeItem(name);
      }
    }

    this.set = function(name, value) {
      if (!value) { return false; }

      this.storer(name, value);
    }


    this.get = function(name) {
      if (!name) { return false; }

      return this.loader(name);
    }


    this.getAsJSON = function(name) {
      return JSON.parse(this.loader(name));
    }

    this.getJSON = function(name) {
      return this.getAsJSON(name);
    }

    this.setAsJSON = function(name, value) {
      this.storer(name, JSON.stringify(value));
      return this.getJSON(name);
    }

    this.setJSON = function(name, value) {
      return this.setAsJSON(name, value);
    }

    if (this.config.onlyJSON) {
      this.get = this.getJSON;
      this.set = this.setJSON;
    }

    // Alias list
    this.save = this.set;
    this.load = this.get;
    this.read = this.get;
  }

  return StorageReader;

})();


(function() {

  /*
    ### READING FROM META TAGS
	*/

  var metasToRead = "[data-store-field^='car_']";
  var fieldList = document.querySelectorAll(metasToRead);

  var getValues = function() {
    var config = {};

    Array.from(fieldList).map(function(field) {
      if (field.content.length > 0) {
        var name = field.getAttribute('data-store-field');
        config[name] = field.content;
      }
    });

    return config;
  }

  var storage = new storageReader({
    onlyJSON: true,
    type: 'session',
    namespace: '__productpage-fields'
  });


  var conf = storage.read("car");

  var fieldsOnPage = getValues();

  if (fieldsOnPage.car_make && fieldsOnPage.car_make.length > 0) {

    // if we don't have a model preference on page, lets try setting data
    // from storage. If its not valid for the maker, it'll be ignored later anyway.
    if (conf && typeof conf === 'object' && typeof conf.car_model !== 'undefined') {
      if (typeof fieldsOnPage.car_model === 'undefined') {
        fieldsOnPage.car_model = conf.car_model;
      }
    }

    storage.set("car", fieldsOnPage);
  }


  var selectListHoldsOption = function(list, value) {
    if (!list || !value) {
      return;
    }

    var match = Array.from(list.options).filter(function(option) {
      if (option.value == value) { 
        return true;
      }
    });

    return !!match.length;
  }

  /*
    ### SETTING FIELDS IN DOM AND LOCALSTORAGE
	*/


  var setCarMake = function(value) {
    var fieldD = document.querySelector('[name="properties[Car Make]');
    var isValid = selectListHoldsOption(fieldD, value);

    if (!isValid) {
      return;
    }

    fieldD.value = value;
    fieldD.dispatchEvent(new Event('change'));

    return value;
  }

  var setCarModel = function(value, carMake) {
    if (!value || !carMake) { return; }

    var carMake = document.querySelector('[name="properties[Car Make]').value;

    var fieldD = document.querySelector('[name="properties[' + carMake + ' Model]');
    
    var isValid = false;


    var carModel = Models.filter(function(item) {
      if (item.Brand == carMake) {
        return true;
      }
    })[0];
    
    var match = carModel.Models.indexOf(value);
    
    if (match > -1) {
      isValid = true;
    }

    if (!isValid) { return false; }

    if (fieldD) {
      fieldD.value = value;
      fieldD.dispatchEvent(new Event('change'));
    }
  }


  /*
    ### SETTING DEFAULTS FROM CONFIG FROM META
  */

  var conf = storage.read("car");

  var carMake = false;

  if (conf) {
    carMake = setCarMake(conf.car_make);
  }

  if (carMake) {
      setCarModel(conf.car_model, carMake); 
  }


  /*
    ### INTERACTIONS
	*/

  // Handle when client change car make
  var makeField = document.querySelector('[data-id="brand"]');

  if (makeField) {
    makeField.addEventListener('change', function(e) {
      var currentConf = storage.get("car") || {};

      if (currentConf.car_make !== makeField.value) {
        currentConf = {};
      }

      currentConf.car_make = makeField.value;
      storage.set("car", currentConf);
    });
  }

  // Handle when client change car model
  var modelField = document.querySelector('select[data-id="model"]');

  if (modelField) {
    modelField.addEventListener('change', function(e) {
      var currentConf = storage.get("car");

      currentConf.car_model = modelField.value;

      storage.set("car", currentConf);
    });
  }
})();